import axios from "axios";
import { storeParamsError, storeParams, loadingParams } from "../actions/paramsActions";
const storageItem = "params";

export async function loadParamsFromStorage(store, apiURL, paramType) {
    try {
        //let params = localStorage.getItem(storageItem);
        //if (!params) {
            store.dispatch(loadingParams())
            await axios
                .get(`${apiURL}/params/${paramType}`, { headers: { Authorization: '' }, })
                .then((result) => {
                    localStorage.setItem(storageItem, btoa(JSON.stringify(result.data)));
                    store.dispatch(storeParams(result.data));
                })
                .catch((error) => {
                    if (error.response.data && error.response.data.title)
                        store.dispatch(storeParamsError({ title: error.response.data.title, message: error.response.data.detail, status: error.response.status }));
                    else
                        store.dispatch(storeParamsError({ title: error.code, message: error.message, status: error.response.status }));
                });
        //} else {
        //    store.dispatch(storeParams(JSON.parse(atob(params))));
        //}
    } catch (e) {
        store.dispatch(storeParamsError(e));
    }
}
